var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prefix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1341 9.55841C10.0508 9.55008 9.95078 9.55008 9.85911 9.55841C7.87578 9.49175 6.30078 7.86675 6.30078 5.86675C6.30078 3.82508 7.95078 2.16675 10.0008 2.16675C12.0424 2.16675 13.7008 3.82508 13.7008 5.86675C13.6924 7.86675 12.1174 9.49175 10.1341 9.55841Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.96758 12.6333C3.95091 13.9833 3.95091 16.1833 5.96758 17.5249C8.25924 19.0583 12.0176 19.0583 14.3092 17.5249C16.3259 16.1749 16.3259 13.9749 14.3092 12.6333C12.0259 11.1083 8.26758 11.1083 5.96758 12.6333Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.8816e08f00e16427aa0fce6875e82bb6.svg";
export { ForwardRef as ReactComponent };